import React from "react";

const CatWalkDutrizacOutline = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='145.75'
      height='160.078'
      fillRule='nonzero'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      clipRule='evenodd'
      version='1.1'
      viewBox='0 0 145.75 160.078'
      xmlSpace='preserve'
      className='clickable'
    >
      <clipPath id='ArtboardFrame'>
        <path d='M0 0H2800V2160H0z'></path>
      </clipPath>
      <g
        fill='rgba(0,0,0,0)'
        className='object-glow'
        stroke='#ff5c97'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='5'
        clipPath='url(#ArtboardFrame)'
        transform='translate(-1659.75)'
      >
        <path
          d='M1667 0s-19 36 19 54c5 0-2.94 12.068 2 18 5 6 8 5.25 14 11s3.25 6.25 7 10 7 3 7 3-6 0-12 10c-7 17-5 47 21 51 9 2 29 0 33-28 5-24-13-32-13-32l-12-2'
          opacity='0.999'
        ></path>
        <path
          d='M1745 97s26-22 29-26c1.9-2.53 2.75-9.5 2-17s-1-10-9-16c-4.69-3.515-29-4-29-4'
          opacity='0.999'
        ></path>
        <path d='M1776 54c3 2 26-6 27-37 0-11-7-17-7-17' opacity='0.999'></path>
        <path d='M1691 40c10-5 21-3 21-3' opacity='0.999'></path>
        <path d='M1698 56s23-10 52-6' opacity='0.999'></path>
      </g>
    </svg>
  );
}

export default CatWalkDutrizacOutline;
